@if (showTitle) {
    <h3>Chat History</h3>
}

<header>
    <hive-button
        class="new-chat-button"
        emphasis="secondary"
        label="New Chat"
        [icon]="faPlus"
        (click)="newConversation.emit()"
    />
    <hive-text-field
        [leftIcon]="faMagnifyingGlass"
        placeholder="Search history"
        [ngModel]="filter"
        (ngModelChange)="onFilterChange($event)"
    />
</header>

@if (conversationGroups.length === 0) {
    <div class="no-history-message">No chat history to show.</div>
}

<div class="conversation-list">
    @for (group of conversationGroups; track group.title) {
        <div class="conversation-list-group">
            <h4>{{ group.title }}</h4>

            @for (convo of group.conversations; track convo.sessionId) {
                <div class="conversation-item-container" [class.active]="isActiveConversation(convo)">
                    <hive-button
                        (click)="clickConversation(convo)"
                        emphasis="tertiary"
                        class="conversation-link"
                        [label]="convo.title"
                        hiveTooltip
                        [hiveTooltipCustomContentTemplateRef]="conversationTooltip"
                        [hiveTooltipCustomContentContext]="{ $implicit: convo }"
                        windowClass="conversation-panel-tooltip"
                        hiveTooltipPosition="bottomLeft"
                    />

                    <hive-button
                        hiveMenuTrigger
                        [menuRef]="sessionMenu"
                        class="conversation-menu"
                        [rounded]="true"
                        emphasis="tertiary"
                        [icon]="faEllipsis"
                    />
                    <hive-menu #sessionMenu="hiveMenu">
                        <hive-menu-item label="Download chat" (click)="clickDownload(convo)" />
                        <hive-menu-item label="Delete chat" (click)="clickDelete(convo)" />
                    </hive-menu>
                </div>
            }
        </div>
    }
</div>

<ng-template #conversationTooltip let-context>
    <div>{{ context.title }}</div>
    <div class="text-muted text-right">
        {{ context.lastUpdated | fromNowImpure }}
    </div>
</ng-template>

<hive-confirmation-dialog
    #deleteConfirmationDialog
    heading="Delete this chat?"
    description="Are you sure you want to delete '{{ conversationToDelete?.title }}'?"
    emphasis="destructive"
    primaryActionLabel="Delete"
    secondaryActionLabel="Cancel"
    (confirm)="clickConfirmDelete()"
    (cancel)="clickCancelDelete()"
/>
